import { AnimatePresence } from "motion/react";
import * as motion from "motion/react-client";
import { useContext, useEffect } from "react";
import { isMobile } from "react-device-detect";
import { ShepherdTourContext } from "../lib/shepherd";

type HamburgerMenuProps = {
  sidebarOpen: boolean;
  onPress: () => void;
};

const HamburgerMenuIcon: React.FC<HamburgerMenuProps> = ({ sidebarOpen, onPress }) => {
  const shepherd = useContext(ShepherdTourContext);
  useEffect(() => {
    if (sidebarOpen && shepherd.isActive() && shepherd.currentStep?.id.includes('Open Sidebar')) {
      shepherd.next();
    }
  }, [sidebarOpen])
  return (
    <AnimatePresence>
      {!sidebarOpen && isMobile && (
        <motion.div
          className="hamburger"
          key="hamburger"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ duration: 0.3 }}
          style={{
            position: "absolute",
            top: "16px",
            left: "16px",
            width: "40px",
            height: "40px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            zIndex: 9999,
          }}
          onClick={onPress}
        >
          {/* Line 1 */}
          <div
            style={{
              width: "30px",
              height: "3px",
              backgroundColor: "#000",
              margin: "4px 0",
              borderRadius: "3px",
            }}
          />
          {/* Line 2 */}
          <div
            style={{
              width: "30px",
              height: "3px",
              backgroundColor: "#000",
              margin: "4px 0",
              borderRadius: "3px",
            }}
          />
          {/* Line 3 */}
          <div
            style={{
              width: "30px",
              height: "3px",
              backgroundColor: "#000",
              margin: "4px 0",
              borderRadius: "3px",
            }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default HamburgerMenuIcon;
